import React, { useEffect, useRef, useImperativeHandle, useState } from "react";
import PropTypes from "prop-types";
import { scrollToErrorElement } from "../../utils/dom";
import classNames from "classnames";
import "../delar-dropdown/style.scss";
import { IS_MOBILE } from "../../constants";

export default function DelarDropdown(props) {
  const { options = [], onChange, onFocus, onBlur, tel = false ,oneOfEdit = false, maxlength = "",showError, className, nodata, warningMessage, selectCode, optionsMaxHeightVal, preventScroll = false } = props;

  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [currentOptionIndex, setCurrentOptionIndex] = useState(-1);
  const [selectedOption, setSelectedOption] = useState(props.selectedOption);
  const [currentOptions, setCurrentOptions] = useState(options);
  const [isOpen, setIsOpen] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [enableFilter, setEnableFilter] = useState(props.enableFilter || false);

  const notchWidth = { width: "auto" };
  const optionsMaxHeight = optionsMaxHeightVal ? optionsMaxHeightVal : 600;

  const wrapperRef = useRef(null);
  const ulRef = useRef(null);
  const labelRef = useRef(null);
  const input = useRef(null);

  useImperativeHandle(props.cRef, () => ({
    option: selectedOption, 
  }));

  const labelClasses = classNames("floating-label", {
    "floating-above": isOpen || selectedOption || isFocused,
    "hasValue": selectedOption?.value
  });

  const outlineLeadingClasses = classNames("notched-outline__leading", {
    focus: isOpen || isFocused,
    "show-warning": showError
  });

  const outlineNotchClasses = classNames("notched-outline__notch", {
    focus: isOpen || isFocused,
    "has-content": selectedOption,
    "show-warning": showError
  });
  const outlineTrailingClasses = classNames("notched-outline__trailing", {
    focus: isOpen || isFocused,
    "show-warning": showError
  });

  const wrapperClassList = classNames("delaer-dropdown", className);

  const contentClassList = classNames("dropdown-content", {
    open: isOpen
  });
  const arrowIconClassList = classNames("arrow", {
    open: isOpen
  });

  const inputClasses = classNames("filter-input");

  const selectClasses = classNames("vertical-align", { error: showError }, { active: tel });

  useEffect(() => {
    if (selectCode && options.length) {
      let sltItem = options.filter(item => item.code.toLowerCase() === selectCode.toLowerCase());
      if (sltItem.length > 0) {
        setSelectedOption(sltItem[0]);
        setSelectedIndex(options.indexOf(sltItem[0]));
      }
    }
    if (currentOptions.length === 0 && options.length === 0) {
      return;
    }
    setCurrentOptions(options);
  }, [options]);

  useEffect(() => {
    setSelectedOption(props.selectedOption);
  }, [props.selectedOption]);

  useEffect(() => {
    !preventScroll && scrollToErrorElement(wrapperRef.current);
  }, [showError]);

  const onComponentBlur = event => {
    event.preventDefault();
    setIsFocused(false);
    setIsOpen(false);
    onBlur(event);
  };

  const optionSelected = (evt, selectedOption, index) => {
    if(selectedOption.code === 'editSelect' && oneOfEdit) {//单独修改某一个
      setEnableFilter(true)
      setIsFocused(true);
      setTimeout(v=>{
        input.current.focus();
        filterOptions('')
      })
    }
    if(selectedOption.code !== 'editSelect' && oneOfEdit) {
      setEnableFilter(false)
      setIsFocused(false);
    }
    if ((!selectedOption?.disabled && isOpen) || (IS_MOBILE && !selectedOption?.disabled)) {
      setSelectedOption(selectedOption);
      setSelectedIndex(index);
      onChange(selectedOption);
      setIsOpen(false);
    }
  };

  const activeOption = index => {
    return classNames("list-item", {
      selected: selectedIndex === index,
      current: currentOptionIndex === index && selectedIndex !== currentOptionIndex
    });
  };

  const highlightListElement = optionElement => {
    const index = options.indexOf(optionElement);
    const optionsHeight = 48;
    ulRef.current.scroll(0, optionsHeight * index);
    setCurrentOptionIndex(index);
  };

  const filterOptions = text => {
    if (text === "") {
      setSelectedOption(null);
      onChange("");
    } else {
      const firstOptionWithMatch = options.filter(({ value }) => value.toLowerCase().startsWith(text.toLowerCase()))[0];
      setSelectedOption({ value: text });
      highlightListElement(firstOptionWithMatch);
    }
  };

  const handleKeyPressSelect = event => {
    event.preventDefault();
    if (!isOpen) {
      setIsOpen(true);
    } else {
      if ( oneOfEdit && currentOptions[currentOptionIndex] ){
        if ( currentOptions[currentOptionIndex].code === 'editSelect' && oneOfEdit ) {      
          setEnableFilter(true)
          setIsFocused(true);
          setTimeout(v=>{
            input.current.focus();
            filterOptions('')
          })
        }
        if( currentOptions[currentOptionIndex].code !== 'editSelect' && oneOfEdit ){
          setEnableFilter(false)
          setIsFocused(false);
        }
      }
      setIsOpen(false);
      setSelectedIndex(currentOptionIndex);
      setSelectedOption(currentOptions[currentOptionIndex]);
      onChange(currentOptions[currentOptionIndex]);
    }
  };

  const handleArrowDown = event => {
    event.preventDefault();
    const nextOptionIndex = currentOptionIndex + 1 <= currentOptions.length ? currentOptionIndex + 1 : 0;
    setCurrentOptionIndex(nextOptionIndex);
  };

  const handleArrowUp = event => {
    event.preventDefault();
    const prevOptionIndex = currentOptionIndex >= 0 ? currentOptionIndex - 1 : currentOptions.length - 1;
    setCurrentOptionIndex(prevOptionIndex);
  };

  const goToLetter = letter => {
    // find first option that stats with leter
    const firstOptionWithMatch = options.filter(({ value }) => value.toLowerCase().startsWith(letter))[0];
    highlightListElement(firstOptionWithMatch);
  };

  const handleArrowNavigation = event => {
    const ARROW_DOWN = 40;
    const ARROW_UP = 38;
    const ENTER = 13;
    const SPACE = 32;
    const A = 65;
    const Z = 90;

    const alphabet = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];

    switch (event.keyCode) {
      case ARROW_DOWN:
        handleArrowDown(event);
        break;
      case ARROW_UP:
        handleArrowUp(event);
        break;
      case ENTER:
        handleKeyPressSelect(event);
        break;
      case SPACE:
        handleKeyPressSelect(event);
        break;
      default:
        if (event.keyCode >= A && event.keyCode <= Z && !enableFilter) {
          goToLetter(alphabet[event.keyCode - A]);
        }
    }
  };

  return (
    <div
      className={wrapperClassList}
      ref={wrapperRef}
      onClick={() => {
        setIsOpen(!isOpen);
      }}
      onFocus={() => {
        setIsFocused(true);
        //setting focus on input so user can type right away
        if (enableFilter && !IS_MOBILE) {
          input.current.focus();
        }
        onFocus();
      }}
      onKeyDown={event => handleArrowNavigation(event)}
      onBlur={onComponentBlur}
      tabIndex={0}
    >
      <div className="select__externalLink">
        <span className={arrowIconClassList}>
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15.0005 6.63013C14.9998 6.7956 14.932 6.95405 14.8119 7.07071L9.27287 12.4858C9.18603 12.5719 9.08254 12.6404 8.9684 12.6871C8.85427 12.7338 8.73178 12.7578 8.60805 12.7578C8.48433 12.7578 8.36184 12.7338 8.2477 12.6871C8.13357 12.6404 8.03008 12.5719 7.94324 12.4858L2.4042 7.07071C2.29947 6.95115 2.24475 6.79737 2.25097 6.64009C2.25718 6.48281 2.32387 6.33361 2.43772 6.22232C2.55156 6.11102 2.70418 6.04582 2.86506 6.03974C3.02594 6.03367 3.18324 6.08716 3.30553 6.18955L8.60805 11.3703L13.9106 6.18955C14 6.10267 14.1136 6.04358 14.2373 6.01968C14.3609 5.99578 14.489 6.00815 14.6055 6.05524C14.722 6.10232 14.8216 6.18202 14.8919 6.2843C14.9622 6.38659 15 6.50691 15.0005 6.63013Z" fill="#1EF1C6"/>
          </svg>
        </span>
        {enableFilter && (
          <input
            ref={input}
            className={inputClasses}
            value={selectedOption ? selectedOption.value : ""}
            maxlength={maxlength}
            onChange={event => {
              filterOptions(event.currentTarget.value);
            }}
          />
        )}
        {!enableFilter && (
          <div className={inputClasses} value={selectedOption ? (selectedOption.value).replace(props.reg,'') : ""}>
            <span className={selectClasses}>{selectedOption ?(selectedOption.value).replace(props.reg,'') : ""}</span>
          </div>
        )}
        <div className={"notched-outline"}>
          <div className={outlineLeadingClasses}></div>
          <div className={outlineNotchClasses} style={notchWidth}>
            {props.placeholder && props.placeholder !== "" && (
              <label ref={labelRef} className={labelClasses}>
                {props.placeholder}
              </label>
            )}
          </div>
          <div className={outlineTrailingClasses}></div>
        </div>
      </div>
      <ul className={contentClassList} style={{ maxHeight: `${optionsMaxHeight}px` }} ref={ulRef}>
        {currentOptions != null &&
          currentOptions.length > 0 &&
          currentOptions.map((option, index) => {
            const optionClass = classNames(activeOption(index), {
              disabled: option.disabled
            });
            return (
              <li className={optionClass} onMouseDown={evt => optionSelected(evt, option, index)} key={index} onMouseOver={() => setCurrentOptionIndex(index)}>
                <div className="value">
                  <span>{option.value}</span>
                  {option.values}
                </div>
                <div className="right">{option?.otherValue}</div>
              </li>
            );
          })}
          {currentOptions != null && currentOptions.length == 0 && nodata &&
           <li className="list-item nodata">{nodata}</li>
          }
      </ul>
      {/* )
            } */}

      {showError && <span className="warning-message">{warningMessage}</span>}
    </div>
  );
}

DelarDropdown.propTypes = {
  className: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      code: PropTypes.string.isRequired
    })
  ),
  selectedOption: PropTypes.shape({
    value: PropTypes.string.isRequired,
    code: PropTypes.string.isRequired
  }),
  placeholder: PropTypes.string,
  warningMessage: PropTypes.string,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
};

DelarDropdown.defaultProps = {
  className: "",
  onChange: () => {},
  onFocus: () => {},
  onBlur: () => {}
};
